import React, { Component } from "react"

export default () => {
  return (
    <div>Ayyy! I'm workin hea!</div>
  )
}